export default __webpack_public_path__ + "static/media/lee-dong-gun.7afc017e.jpg";